import BaseComponent from '@components/base-component';
import { createAddButton, createClearButton, createLoadButton, createPasteButton, createSaveButton, createStartButton, } from './create-buttons';
import * as styles from './options-controls.module.scss';
export default class Controls extends BaseComponent {
    machine;
    constructor(machine, callbacks) {
        super({ elementTag: 'div', classes: [styles.buttons] });
        this.machine = machine;
        const { add, paste, clear, start } = callbacks;
        const addButton = createAddButton(add);
        const pasteButton = createPasteButton(paste);
        const clearButton = createClearButton(clear);
        const saveButton = createSaveButton(this.saveOptions.bind(this));
        const loadButton = createLoadButton(this.loadOptions.bind(this));
        const startButton = createStartButton(start);
        this.appendChildren(addButton, pasteButton, clearButton, saveButton, loadButton, startButton);
    }
    saveOptions() {
        this.machine.makeTransition(this.machine.value, 'saveToFile');
    }
    loadOptions() {
        this.machine.makeTransition(this.machine.value, 'loadFromFile');
    }
}
